module.exports = __webpack_public_path__ + "static/media/image10.f35c9f7e.jpg";